<template>
  <div>
    <Nav />
    <div class="groupInfo_box">
      <el-row>
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="24"
          :xl="24"
          :offset="1"
          class="groupInfo_title flex pageTitle"
          style="padding:60px 0px 30px;"
        >
          <span>团组成员：({{tableData.length}} 人)</span>
          <div>
            <el-button type="primary" @click="addMember" :style="btnAllStyle">添加团组成员</el-button>
            <el-button type="primary" v-if="DownloadGroupSwitch" @click="downList" :style="btnAllStyle" :disabled="tableData.length<=0">下载列表</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :offset="1">
          <el-table style="width:100%" :data="tableData">
            <el-table-column label="登录名(邮箱)" prop="PsjEmail"></el-table-column>
            <el-table-column label="密码" prop="PsjPwd"></el-table-column>
            <el-table-column label="姓名" prop="PsjName"></el-table-column>
            <el-table-column label="职务" prop="PsjRank"></el-table-column>
            <el-table-column label="手机" prop="PsjMobile"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import api from '../api'
import Nav from '../components/Nav'
export default {
  name: 'GroupRegister',
  components: {
    Nav
  },
  data() {
    return {
      ExhID: sessionStorage.getItem('ExhID'),
      PsnID: sessionStorage.getItem('PsnID'),
      tableData: [],
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {},
      GroupListNumber: 0, // 团组人数限制
      DownloadGroupSwitch: false // 是否开启下载
    }
  },
  mounted() {
    this.savePsnID(this.getGroupList) // 获取团组列表
    this.bannerImg = sessionStorage.getItem('bannerImg')
    this.getConfigInfo();
  },
  methods: {
    getConfigInfo() {
      var That = this
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'GroupList'
      }
      api.getPage(param).then(res => {
        if(res.data.status === 'OK') {
          res.data.promptinfo.forEach(ele => {
            if(ele.name === 'GroupListNumber') {
              if (ele.value) {
                That.GroupListNumber = parseInt(ele.value)
                sessionStorage.setItem('GroupListNumber', That.GroupListNumber)
              }
            }
          })
          res.data.switchInfos.forEach(ele => {
            if(ele.name === 'DownloadGroupSwitch') {
              That.DownloadGroupSwitch = ele.data
            }
          })
        }else{
          That.$alert(res.data.ErrorMsg)
        }
      })
    },
    addMember() {
      if ((this.GroupListNumber !== 0) && (this.GroupListNumber <= this.tableData.length)) {
        // 如果已到达人数上限
        this.$alert('已到达人数上限')
      } else {
        sessionStorage.setItem('groupInfoLength', this.tableData.length)
        this.$router.push('addMember')
      }
    },
    downList: function() {
      var params = {
        ExhID: this.ExhID,
        PsnID: sessionStorage.getItem('PsnID')
      }
      location.href = api.groupMembersExport(params)
    },

    savePsnID: function(cb) {
      this.PsnID = sessionStorage.getItem('PsnID')
      if (this.PsnID && cb) {
        cb()
      } else {
        var params = {
          ExhID: this.ExhID,
          PsjID: sessionStorage.getItem('PsjID')
        }
        api.getRegistInfo(params).then(res => {
          sessionStorage.setItem('PsnID', res.Data.PsnID)
          if (cb) {
            cb()
          }
        })
      }
    },

    getGroupList: function() {
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var params = {
        ExhID: this.ExhID,
        PsnID: sessionStorage.getItem('PsnID'),
        Language: 'cn'
      }
      api.groupMembers(params).then(res => {
        loading.close()
        if (res.data.status === 'OK') {
          this.tableData = res.data.Data
        } else {
          this.$alert(res.data.ErrorMsg)
        }
      })
    }
  }
}
</script>
<style>
.groupInfo_box {
  min-height: calc(60vh);
  background: #fff;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 15px;
}
.add-member {
  float: right;
  margin: 10px;
}
.down-member {
  float: right;
  margin: 10px;
}
.el-col-offset-1 {
  margin-left: 0;
}
.el-button + .el-button {
  margin-left: 0;
}
.groupInfo_title {
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/GroupRegister.vue